import { CategoryFilter, CategoryFilterType } from '../category-filter.model';
import { FilterSupportedType, StringValueId } from '../filter-supported-type.model';

// tslint:disable-next-line:no-empty-interface
export class GenericRadioFilter {
  value: StringValueId;
}

export class GenericRadioCategoryFilter extends CategoryFilter {
  get type() { // Workaround for « typeof » , typeof (object) === "mytype" doesn't work always has expected
    return CategoryFilterType.Radio;
  }

  get showFilter(): boolean {
    return (this.filters) && this.filters.length > 0;
  }

  private _selected: GenericRadioFilter;

  get selected(): GenericRadioFilter {
    return this._selected;
  }

  set selected(value: GenericRadioFilter) {
    this._selected = value;
  }

  name: string;
  filters: GenericRadioFilter[];

  reset() {
    if (this.filters) {
      this._selected = this.filters[0] || null;
    }
  }

  resetByValue(valueToSelect: string) {
    if (this.filters) {
      for (let i = 0; i < this.filters.length; i++) {
        if (this.filters[i].value.id === valueToSelect) {
          this._selected = this.filters[i];
          return;
        }
      }
      this._selected = this.filters[0] || null;
    }
  }

}
